import { cn } from '../../lib/utils';

export interface HorizonOption<T extends string> {
  value: T;
  label: string;
  caption?: string;
}

interface HorizonSelectorProps<T extends string> {
  label: string;
  options: ReadonlyArray<HorizonOption<T>>;
  value: T;
  onChange: (value: T) => void;
}

export function HorizonSelector<T extends string>({
  label,
  onChange,
  options,
  value,
}: HorizonSelectorProps<T>) {
  return (
    <div className="flex flex-wrap gap-1" role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
          className={cn(
            'flex min-w-14 flex-col items-center rounded border px-2.5 py-1 text-xs transition',
            option.value === value
              ? 'border-text bg-text text-bg'
              : 'border-border bg-bg-muted text-text-muted hover:text-text',
          )}
        >
          <span className="font-semibold">{option.label}</span>
          {option.caption ? <span className="text-[10px]">{option.caption}</span> : null}
        </button>
      ))}
    </div>
  );
}
